module.exports = __webpack_public_path__ + "media/images/share/almostchristmas-e77e73be98c901c8d25c7dc53fdd4d58.png";